import { IEntityTypeConfig } from "../types";

export const ENTITY_BULK_ASSIGNMENT_API_PATHS = {
  BULK_UPDATE_ASSIGNMENT:
    "v1/organization/{0}/employee-profiles/bulk-update-assignment/",
};

export const MAX_BULK_REASSIGN_COUNT = 100;

export const ENTITY_TYPE_CONFIG: Record<
  "EMPLOYEE_GRADE" | "COST_CENTER" | "DEPARTMENT",
  IEntityTypeConfig
> = {
  EMPLOYEE_GRADE: {
    assignmentType: "EMPLOYEE_GRADE",
    label: "employee grade",
    labelPlural: "employee grades",
    titleCase: "Employee Grade",
    deleteTitle: "Delete Employee Grade",
    assignModalTitle: "Assign to Multiple Employee Grades",
    assignStepLabel: "Assign Employee Grade",
    selectPlaceholder: "Select new employee grade",
    icon: "m-other-facilities",
  },
  COST_CENTER: {
    assignmentType: "COST_CENTER",
    label: "cost center",
    labelPlural: "cost centers",
    titleCase: "Cost Center",
    deleteTitle: "Delete Cost Center",
    assignModalTitle: "Assign to Multiple Cost Centers",
    assignStepLabel: "Assign Cost Center",
    selectPlaceholder: "Select new cost center",
    icon: "m-currency-conversion",
  },
  DEPARTMENT: {
    assignmentType: "DEPARTMENT",
    label: "department",
    labelPlural: "departments",
    titleCase: "Department",
    deleteTitle: "Delete Department",
    assignModalTitle: "Assign to Multiple Departments",
    assignStepLabel: "Assign Department",
    selectPlaceholder: "Select new department",
    icon: "m-info",
  },
};
